// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M12,7.5c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S14.5,7.5,12,7.5z M12,15.5c-1.9,0-3.5-1.6-3.5-3.5
		s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5S13.9,15.5,12,15.5z M21.8,13.9c0.1-0.6,0.2-1.3,0.2-1.9c0-0.6-0.1-1.3-0.2-1.9l-2.1-0.3
		c-0.2-0.6-0.4-1.2-0.7-1.7l1.3-1.7c-0.7-1.1-1.6-2-2.7-2.7L15.9,5l-1.7-0.7l-0.3-2.1L12,2l-1.9,0.2L9.8,4.3L8.1,5L6.4,3.7
		c-1.1,0.7-2,1.6-2.7,2.7L5,8.1C4.7,8.6,4.5,9.2,4.3,9.8l-2.1,0.3C2.1,10.7,2,11.4,2,12c0,0.6,0.1,1.3,0.2,1.9l2.1,0.3
		c0.2,0.6,0.4,1.2,0.7,1.7l-1.3,1.7c0.7,1.1,1.6,2,2.7,2.7L8.1,19l1.7,0.7l0.3,2.1L12,22l1.9-0.2l0.3-2.1l1.7-0.7l1.7,1.3
		c1.1-0.7,2-1.6,2.7-2.7L19,15.9c0.3-0.5,0.5-1.1,0.7-1.7L21.8,13.9z M18.9,13.2l-0.2,0.7c-0.1,0.5-0.3,1-0.6,1.5L17.8,16l0.4,0.5
		l0.8,1.1c-0.4,0.5-0.9,1-1.4,1.4l-1.1-0.8L16,17.8l-0.6,0.3c-0.5,0.3-1,0.5-1.5,0.6l-0.7,0.2v0.7L13,20.9h-2l-0.2-1.3v-0.7
		l-0.7-0.2c-0.5-0.1-1-0.3-1.5-0.6L8,17.8l-0.5,0.4L6.4,19c-0.5-0.4-1-0.9-1.4-1.4l0.8-1.1L6.2,16l-0.3-0.6c-0.3-0.5-0.5-1-0.6-1.5
		l-0.2-0.7H4.4L3.1,13C3,12.7,3,12.3,3,12c0-0.3,0-0.7,0.1-1l1.3-0.2h0.7l0.2-0.7c0.1-0.5,0.3-1,0.6-1.5L6.2,8L5.8,7.5L5,6.4L6.4,5
		l1.1,0.8L8,6.2l0.6-0.3c0.5-0.3,1-0.5,1.5-0.6l0.7-0.2V4.4L11,3.1h2l0.2,1.3v0.7l0.7,0.2c0.5,0.1,1,0.3,1.5,0.6L16,6.2l0.5-0.4
		L17.6,5c0.5,0.4,1,0.9,1.4,1.4l-0.8,1.1L17.8,8l0.3,0.6c0.3,0.5,0.5,1,0.6,1.5l0.2,0.7h0.7l1.3,0.2c0.1,0.3,0.1,0.7,0.1,1
		c0,0.3,0,0.7-0.1,1l-1.3,0.2H18.9z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-settings-BchWbTHI.js.map
